<div class="section-container" id="developerName">
  <div class="section-header">
    <div class="title-cont">
      <img src="/assets/icons/icon-search.svg" width="21" height="26" alt="Identity Risk Icon" />
      <h2>Identity Risk</h2>
    </div>
    <h3 class="sub-title">Measuring the risk associated with unclear or unverifiable developer identity, including
      missing contact information or anonymous website registrations.</h3>
  </div>

  <div class="sub-section">
    <h3>Developer Contact Info:</h3>
    <div class="grid-container">
      <div class="grid-item">
        <img src="/assets/icons/icon-developer.svg" width="20" height="20" alt="Developer Icon" />
        <span>Developer Name</span>
        <p>{{ data?.developerName || 'N/A'}}</p>
      </div>

      <div class="grid-item">
        <img src="/assets/icons/icon-email.svg" width="20" height="20" alt="Developer Email Icon" />
        <span>Developer Email</span>
        <p>{{ data?.contactEmail || 'N/A'}}</p>
      </div>

      <div class="grid-item">
        <img src="/assets/icons/icon-globe.svg" width="20" height="20" alt="Developer Website Icon" />
        <span>Developer Website</span>
        <p>
          <ng-container *ngIf="data?.contactWebsite">
            <a class="btn-link" enTooltip [title]="data?.contactWebsite" [href]="data?.contactWebsite"
              target="_blank">{{ data?.contactWebsite }}</a>
          </ng-container>
          <ng-container *ngIf="!data?.contactWebsite">
            N/A
          </ng-container>
        </p>
      </div>

      <div class="grid-item">
        <img src="/assets/icons/icon-flag.svg" width="20" height="20" alt="Developer Country Icon" />
        <span>Developer Country</span>
        <p>
          <img src="//cdn.pixalate.com/icons/countries/flat/48/{{data?.developerCountryCode}}.png"
            onerror="this.src='/assets/icons/icon-flag.png';" width="18" height="18" alt="Flag Icon"
            title="{{ data?.developerCountry }}" data-animation="false" />
          <span>{{ data?.developerCountry || 'Unknown' }}</span>
        </p>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div class="sub-section grid-container" id="missingContactRisk">
    <div class="grid-item">
      <div class="mb-1">
        <img src="/assets/icons/icon-note.svg" width="20" height="20" alt="Anonymous Owner Risk Icon" />
        <span>Anonymous Owner Risk</span>
        <i class="fa fa-info-circle ml-2 tooltip-icon" enTooltip
          [attr.title]="'Indicates whether the app developer\'s website is anonymously registered with internet domain databases.'"></i>
      </div>
      <span *ngIf="data?.whoisRisk == 'High'" class="whois">Anonymous Registration</span>
      <span *ngIf="data?.whoisRisk == 'Low'" class="whois low">Public Registration</span>
    </div>
    <div class="grid-item">
      <img src="/assets/icons/icon-users.svg" width="20" height="20" alt="Consumer Reach Icon" />
      <span>Consumer Reach</span>
      <p>{{ data?.lifetimeUsersRange }}</p>
    </div>
  </div>

  <div class="divider"></div>

  <div class="sub-section">
    <h3>App Portfolio:</h3>
    <div class="grid-container">
      <div class="grid-item">
        <span class="field-title">Total Apps:</span>
        <span class="field-value">{{ data?.totalApps }}</span>
      </div>
      <div class="grid-item">
        <span class="field-title">Abandoned Apps:</span>
        <span class="field-value">{{ data?.abandonedApps }}</span>
      </div>
      <div class="grid-item">
        <span class="field-title">Child Directed Apps:</span>
        <span class="field-value">{{ data?.childDirectedApps }}</span>
      </div>
      <div class="grid-item">
        <span class="field-title">Delisted Apps:</span>
        <span class="field-value">{{ data?.delistedApps }}</span>
      </div>
    </div>
  </div>
</div>